import Axios from "../../configs/axios.config";

export const getinitialDetail = (data) =>
  Axios.get("/inventory/initial-detail", { params: data }).then(
    (response) => response.data.data
  );
//category
export const createCategory = (data) =>
  Axios.post(`/inventory/category`, data).then(
    (response) => response.data
  );
export const updateCategory = (data, id) =>
  Axios.put(`/inventory/category/${id}`, data).then(
    (response) => response.data
  );
export const getCategoryList = (data) =>
  Axios.get("/inventory/category", { params: data }).then(
    (response) => response.data
  );
export const getCategoryDetail = (id) =>
  Axios.get(`/inventory/category/${id}`).then((response) => response.data);

export const deleteCategory = (id) => Axios.delete(`/inventory/category/${id}`);

//PurchaseRequest

export const createPurchaseRequest = (data) =>
  Axios.post(`/inventory/purchase-request`, data).then(
    (response) => response.data.data
  );
export const updatePurchaseRequest = (data, id) =>
  Axios.post(`/inventory/purchase-request/${id}`, data).then(
    (response) => response.data.data
  );
export const getPurchaseRequestList = (data) =>
  Axios.get("/inventory/purchase-request", { params: data }).then(
    (response) => response.data
  );
export const getPurchaseRequestDetail = (id) =>
  Axios.get(`/inventory/purchase-request/${id}`).then(
    (response) => response.data
  );
export const deletePurchaseRequest = (id) =>
  Axios.delete(`/inventory/purchase-request/${id}`);

// purchasse order
export const createPurchaseOrder = (data) =>
  Axios.post(`/inventory/purchase-order`, data).then(
    (response) => response.data.data
  );
export const updatePurchaseOrder = (data, id) =>
  Axios.post(`/inventory/purchase-order/${id}`, data).then(
    (response) => response.data.data
  );
export const getPurchaseOrderList = (data) =>
  Axios.get("/inventory/purchase-order", { params: data }).then(
    (response) => response.data
  );
export const getPurchaseOrderDetail = (id) =>
  Axios.get(`/inventory/purchase-order/${id}`).then(
    (response) => response.data.data
  );
export const deletePurchaseOrder = (id) =>
  Axios.delete(`/inventory/purchase-order/${id}`);

//stock

export const createStock = (data) =>
  Axios.post(`/inventory/stock`, data).then((response) => response.data.data);

export const updateStock = (data, id) =>
  Axios.put(`/inventory/stock/${id}`, data).then(
    (response) => response.data.data
  );
export const getStockList = (data) =>
  Axios.get("/inventory/stock", { params: data }).then(
    (response) => response.data
  );
export const getStockDetail = (id) =>
  Axios.get(`/inventory/stock/${id}`).then((response) => response.data);

export const deleteStock = (id) => Axios.delete(`/inventory/stock/${id}`);


export const getAssignedList = (data) =>
  Axios.get(`/inventory/stock/assigned-history`, {
    params: data,
  }).then((response) => response.data.data);

export const assignStock = (data) =>
  Axios.post(`/inventory/stock/assign`, data).then(
    (response) => response.data.data
  );
export const getStockItemsDetail = (id,data) =>
  Axios.get(`/inventory/stock/items/${id}`, { params: data }).then((response) => response.data);
  

export const getPurchaseHistoryList = (id,data) =>
  Axios.get(`/inventory/stock/purchase-history/${id}`, { params: data }).then((response) => response.data);


// vendor
export const createVendor = (data) =>
  Axios.post(`/inventory/vendor`, data).then((response) => response.data.data);

export const updateVendor = (data, id) =>
  Axios.put(`/inventory/vendor/${id}`, data).then(
    (response) => response.data.data
  );
export const getVendorList = (data) =>
  Axios.get("/inventory/vendor", { params: data }).then(
    (response) => response.data
  );
export const getVendorDetail = (id, data) =>
  Axios.get(`/inventory/vendor/${id}`, {params : data}).then((response) => response.data);
export const deleteVendor = (id) => Axios.delete(`/inventory/vendor/${id}`);

// purchase Invoice
export const createPurchaseInvoice = (data) =>
  Axios.post(`/inventory/purchase-invoice`, data).then(
    (response) => response.data.data
  );
export const updatePurchaseInvoice = (data, id) =>
  Axios.post(`/inventory/purchase-invoice/${id}`, data).then(
    (response) => response.data.data
  );
export const getPurchaseInvoiceList = (data) =>
  Axios.get("/inventory/purchase-invoice", { params: data }).then(
    (response) => response.data
  );
export const getPurchaseInvoiceDetail = (id) =>
  Axios.get(`/inventory/purchase-invoice/${id}`).then(
    (response) => response.data.data
  );
export const deletePurchaseInvoice = (id) =>
  Axios.delete(`/inventory/purchase-invoice/${id}`);


export const getPurchaseInvoicePrint = (id, data) =>
  Axios.get(`/inventory/purchase-order/download/${id}`, {
    params: data,
  }).then((res) => res.data);

export const payInvoice = ( data) =>
  Axios.post(`/inventory/purchase-order-payment`, data).then(
    (response) => response.data
  );
